export const MSG_ERRO_PREENCHIMENTO_OBRIGATORIO = 'Preenchimento obrigatório.'
export const MSG_ERRO_NAO_DEVE_SER_PREENCHIDO = 'Não deve ser preenchido.'
